'use strict'
const baseApiUrl = process.env.VUE_APP_ROOT_API
const ISPROD = baseApiUrl.includes('metru.de')
const URL = process.env.VUE_APP_ROOT_API.replace(/^(https?:|)\/\//, '')
export default {
  ISPROD,
  URL,
  BASE_URL: baseApiUrl,
  BASE_API_LOGIN_URL: baseApiUrl,
  BASE_API_URL: baseApiUrl + '/v1',
  BASE_API_URL_V2: baseApiUrl + '/v2',
  DEFAULT_PROFILE_PIC: '/assets/img/default-pic.png',
  DEFAULT_JOBAD_THUMB: '/assets/img/jobad-thumb.jpg',
  DEFAULT_JOBVIDEO_THUMB: '/assets/img/hiring-jobvideo.png',
}
